import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { SitesBuilderLibComponent } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from './sb-editor-tools/services/tools.service';
import { MinisiteConfiguration, SiteParams } from '@3ddv/ngx-sites-builder-lib';
import { SblibService } from './services/sblib.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { SaveMinisiteComponent } from './modals/save-minisite/save-minisite.component';
import { SiteModel, WorkflowModel } from '../../models/site.model';
import { ToastrService } from 'ngx-toastr';
import { SidebarService } from './sb-editor-sidebar/services/sidebar.service';
import { Sidebar } from './sb-editor-sidebar/models/sidebar.model';
import { VersionService } from './sb-editor-sidebar/services/version.service';
import { UtilsService } from '../../services/utils.service';
import { BreadcrumbsService } from 'src/app/layout/breadcrumbs/service/breadcrumbs.service';
import { Workflow } from '@3ddv/ngx-sites-builder-lib/lib/workflows/models/workflow.model';
import { ClientListFromKeys } from 'src/app/auth/private/components/client/models/client.model';
import { CdVenueModel } from 'src/app/content-distribution/private/entities/venues/models/venue.model';

@Component({
  selector: 'app-sb-editor',
  templateUrl: './sb-editor.component.html',
  styleUrls: ['./sb-editor.component.scss'],
})
export class SbEditorComponent implements OnInit, OnDestroy {
  @ViewChild('sitebuilder', { static: false })
  sitebuilder: SitesBuilderLibComponent;

  public subscriptions: Array<Subscription>;
  public minisiteConfiguration: MinisiteConfiguration;
  public minisiteConfigurationParams: SiteParams;
  public minisitedb: SiteModel;
  public workflow: WorkflowModel;
  public venue: CdVenueModel;
  public authClients: ClientListFromKeys[];
  public sblibReady: boolean;
  private bsModalRef?: BsModalRef;
  public editmode: {
    active: boolean;
    venue_id: string;
    map_id: string;
  };
  public sidebar: Sidebar = {
    active: '',
    text: '',
    grid: {
      hidden: false,
      extended: false,
    },
  };

  constructor(
    private toolsService: ToolsService,
    private toastrService: ToastrService,
    private utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private router: Router,
    private sidebarService: SidebarService,
    private sblibService: SblibService,
    private breadcrumbsService: BreadcrumbsService,
    private versionService: VersionService
  ) {
    this.subscriptions = [];
    this.workflow = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.dataFlow.workflow));
    // console.log('Workflow: ', this.workflow);
    this.venue = this.activatedRoute.snapshot.data.dataFlow.venue;
    // console.log(this.venue);
    this.authClients = this.activatedRoute.snapshot.data.dataFlow.clients;
    // console.log(this.activatedRoute.snapshot.data);
    this.minisiteConfiguration = {
      mapConfig: {
        map_id: this.workflow.map_id,
        venue_id: this.workflow.venue_id,
        workflow_id: this.workflow.id,
        enabled: true,
        client: '',
        set_id: '',
      },
      toolsConfig: {},
    };
    this.editmode = {
      active: false,
      venue_id: this.workflow.venue_id,
      map_id: this.workflow.map_id,
    };

    if (this.activatedRoute.snapshot.data.site) {
      // console.log('Snapshot data: ', this.activatedRoute.snapshot.data);
      this.venue = this.activatedRoute.snapshot.data.site.venue;
      // console.log('Venue: ', this.venue);
      const siteData = JSON.parse(JSON.stringify(this.activatedRoute.snapshot.data.site));
      // console.log('siteData: ', siteData);

      this.minisitedb = siteData.site;
      // console.log(siteData);
      this.minisiteConfiguration.mapConfig.client = siteData.site.title;
      this.minisiteConfiguration.mapConfig.workflow_id = siteData.site.workflow_id;
      this.minisiteConfiguration.mapConfig.enabled = siteData.site.is_active;
      this.minisiteConfiguration.mapConfig.set_id = siteData.master.mapConfig.set_id;
      this.minisiteConfiguration.mapConfig.map_id = siteData.site.map_id;
      this.minisiteConfiguration.mapConfig.venue_id = siteData.site.venue_code;
      this.editmode.venue_id = siteData.site.venue_code;
      this.editmode.map_id = siteData.site.map_id;

      if (siteData.master) {
        this.minisiteConfiguration.toolsConfig = JSON.parse(JSON.stringify(siteData.master));
        // this.minisiteConfiguration.toolsConfig = Object.assign(
        //   {},
        //   this.activatedRoute.snapshot.data.site.master
        // );
      }
    }

    this.versionService.setMinisiteConfigAsync$(this.minisiteConfiguration.mapConfig);
    this.sblibReady = false;
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      // console.log('Tools (SB Editor): ', res);
      this.sblibService.setMapconfig(this.minisiteConfiguration.mapConfig);

      // Just in case site's minimap.map_id doesn't exist, but don't overwrite it if it does.
      if (res.minimap && !res.minimap.map_id) {
        res.minimap.map_id = this.workflow.minimap_id;
      }

      this.minisiteConfiguration.toolsConfig = JSON.parse(JSON.stringify(res));

      this.minisiteConfigurationParams = {
        iframeMode: null,
        viewId: null,
        siteId: null,
      };
    });
    this.subscriptions.push(tools$);

    const sidebar$ = this.sidebarService.getSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);

    const panoversion$ = this.versionService.getPanoVersion$().subscribe(res => {
      // console.log('RES: ', res);
      this.minisiteConfiguration.mapConfig.set_id = res;
    });
    this.subscriptions.push(panoversion$);

    // Breadcrumbs
    const bc = [
      {
        label: 'Dashboard',
        url: '/dashboard',
      },
      {
        label: 'Sitesbuilder',
        url: '/sitesbuilder/private/list',
      },
      {
        label: 'Workflows',
        url: '/sitesbuilder/private/workflows',
      },
    ];
    if (this.minisiteConfiguration.mapConfig.client) {
      bc.push({
        label: 'Editar',
        url: '',
      });
    } else {
      bc.push({
        label: 'Crear',
        url: '',
      });
    }
    this.breadcrumbsService.set(bc);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.sblibService.sblib = this.sitebuilder;
    this.sblibService.setSblibReady();
  }

  public saveSite() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      this.minisiteConfiguration.toolsConfig = res;
      const initialState: object = {
        minisiteConfiguration: this.minisiteConfiguration,
        minisiteDB: this.minisitedb,
        workflow: this.workflow,
        venue: this.venue,
        authClients: this.authClients,
        libVersion: this.sitebuilder.libVersion(),
      };

      const modalConfig: ModalOptions = {
        animated: true,
        backdrop: true,
        ignoreBackdropClick: true,
        initialState,
        class: 'create-minisite',
      };
      this.bsModalRef = this.modalService.show(SaveMinisiteComponent, modalConfig);

      const onHide$ = this.bsModalRef.onHide.subscribe((response: ModalOptions) => {
        // console.log(response);
        // console.log(this.bsModalRef.content);
        console.log(this.bsModalRef.content.closeReason);
        if (this.bsModalRef.content.closeReason == 'success') {
          //this.router.navigate(['/sitesbuilder/admin/list']);
          window.location.href = '/sitesbuilder/private/list';
        }
      });
      this.subscriptions.push(onHide$);
    });
    this.subscriptions.push(tools$);
  }

  public editMapConfig() {
    if (this.activatedRoute.snapshot.data.site) {
      let siteid = this.activatedRoute.snapshot.data.site.site.id;
      window.location.href =
        '/sitesbuilder/private/editor/' +
        this.workflow.id +
        '/' +
        siteid +
        '?venue_id=' +
        this.editmode.venue_id +
        '&map_id=' +
        this.editmode.map_id;
    } else {
      window.location.href =
        '/sitesbuilder/private/editor/' +
        this.workflow.id +
        '?venue_id=' +
        this.editmode.venue_id +
        '&map_id=' +
        this.editmode.map_id;
    }
  }

  public redirectRefreshed(url: string) {
    this.utilsService.redirectRefreshed((window.location.href = url));
  }
}
